import { BlockStack, Text } from '@shopify/polaris';
import { AdminLegacyGarageOperation } from '../../app/models/Admin';

const stages: Record<string, string> = {
  ValidateSource: 'Verify source store', ScanGarages: 'Scan saved garages', CatchUpGarages: 'Catch up garage changes',
  VerifyGarages: 'Verify garage coverage', ResolveTarget: 'Find PFV2 target', LockTarget: 'Wait for PFV2 operations',
  LockSource: 'Wait for PFV1 operations', CheckReadiness: 'Check worker readiness', ValidateRoute: 'Verify current route',
  VerifyWorker: 'Verify worker lease', EnrollTarget: 'Enroll PFV2 target', FinalGarageCatchUp: 'Apply final garage changes',
  ValidateReplica: 'Verify replication mapping', ReadSourceBaseline: 'Read PFV1 baseline', ReadTargetBaseline: 'Read PFV2 baseline',
  SaveReplicaCheckpoint: 'Save replication checkpoint', ImportReplica: 'Import PFV1 baseline', PromoteGarages: 'Activate prepared garages',
  DrainWrites: 'Deliver pending writes', CommitRoute: 'Switch serving backend', ReadFinalStatus: 'Confirm final status',
  CompleteOperation: 'Save completion status',
};

export default function PilotFailureDetails({ operation }: { operation: AdminLegacyGarageOperation }) {
  return <BlockStack gap="100">
    {operation.failureStage ? <Text as="p">Failed step: {stages[operation.failureStage] || operation.failureStage}.</Text> : null}
    <Text as="p">{operation.failureDetail || 'This older run recorded only the error code. A new run with the updated worker will capture the failed step and diagnostic details.'}</Text>
    <Text as="p" tone="subdued">Error code: {operation.failureCode || 'Unknown'}.</Text>
  </BlockStack>;
}
